export default {
    LOAD_BUDGET_TEMPLATE(state, budget_template) {
        state.items = budget_template;
    }
}